module.exports = "<order-list customer=\"pvm.customer\" extra-fields=\"['fields']\"></order-list>\n<div id=\"create-button\" class=\"bottom-right-icon-button\" permission permission-only=\"'main.add_order'\">\n    <div class=\"btn btn-primary btn-fab\"\n        role=\"button\"\n        title=\"Create new order\"\n        aria-label=\"Create new order\"\n        ng-click=\"vm.create()\">\n            <i class=\"btn-icon fa fa-plus\" aria-hidden=\"true\"></i>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/customers/order.list.html
// module id = 712
// module chunks = 0